import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataListingProviderComponent } from 'src/app/shared/components/data-listing-provider/data-listing-provider.component';
import { AuthenticationGuard } from 'src/app/shared/guard/authentication-guard';
import { Entity } from 'src/app/shared/store/view/types';
import { HasUnsavedChangesGuard } from '../../../shared/guard/has-form-changed.guard';
import { ModuleId } from '../../../shared/store/navigation/types';
import { HeaderMenuType } from '../../../shared/store/view/types';
import { ContractTerminationReasonCreateComponent } from './contract-termination-reason-create/contract-termination-reason-create.component';
import { ContractTerminationReasonDetailsComponent } from './contract-termination-reason-details/contract-termination-reason-details.component';
import { ContractTerminationReasonEditComponent } from './contract-termination-reason-edit/contract-termination-reason-edit.component';

const routes: Routes = [
  {
    path: 'Insurance/ContractTerminationReasons',
    data: {
      breadcrumb: { label: ' ', alias: 'list' },
    },
    children: [
      {
        path: '',
        redirectTo: 'List',
        pathMatch: 'full',
      },
      {
        path: 'List',
        component: DataListingProviderComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.insurance,
          entity: Entity.ContractTerminationReason,
          breadcrumb: { skip: true },
        },
      },
      {
        path: 'Details/:id',
        component: ContractTerminationReasonDetailsComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.insurance,
          entity: Entity.ContractTerminationReason,
          breadcrumb: { label: ' ', alias: 'contractTerminationReasonDetails' },
        },
      },
      {
        path: 'Create',
        component: ContractTerminationReasonCreateComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.insurance,
          entity: Entity.ContractTerminationReason,
          breadcrumb: { label: ' ', alias: 'contractTerminationReasonCreate' },
        },
      },
      {
        path: 'Edit/:id',
        component: ContractTerminationReasonEditComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.insurance,
          entity: Entity.ContractTerminationReason,
          breadcrumb: { label: ' ', alias: 'contractTerminationReasonEdit' },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContractTerminationReasonRoutingModule {}
